// extracted by mini-css-extract-plugin
export default {"section":"Ps-z","inSectionButton":"Qs-z","addressCard":"Rs-z","disabled":"Ss-z","cautionBox":"Ts-z","failureBox":"Us-z","fade-out":"Vs-z","successBox":"Ws-z"};